import React, {useContext } from 'react';
import {
    Heading,
    Checkbox,
    IconRewards,
    IconPaperless,
    IconEmail,
    IconInsurance,
    dlsBrightBlue
} from '@americanexpress/dls-react';
import parse from "html-react-parser";
import userContext from '../../components/ContextComponent/UserContext';

function CommunicationPreference({ cardName }) {
    const { formData, setFormData } = useContext(userContext);   

    const valueChangeOnlineStatement = (e) => {
        setFormData({ ...formData, onlineStatements: e.target.checked });
    }
    const valueChangeEmailCommunication = (e) => {
        setFormData({ ...formData, emailCommunication: e.target.checked });
    }
    const valueChangeInsurancePlanCommunication = (e) => {
        setFormData({ ...formData, insurancePlanCommunication: e.target.checked });
    }
    const valueChangeAdditionalPreviliges = (e) => {
        setFormData({ ...formData, additionalPreviliges: e.target.checked });
    }
    const valueChangeMarketingCommunicationOverPhone = (e) => {
        setFormData({ ...formData, marketingCommunicationOverPhone: e.target.checked });
    }
    //const handleMITCCommunicationModeChange = (e) => {
    //    setFormData({ ...formData, communicationMode: e.target.value });
    //    setErrorData({ ...errorData, communicationModeRequired: false });
    //}

    return (
        <div className="margin-4-t">
            <Heading level="3" className="margin-2-b heading-3 text-uppercase"> Agreements </Heading>
            <div className="flex margin-1-t">
                <IconRewards theme={dlsBrightBlue} filled={true} title="accessibility icon" />
                <Heading level={2} headingStyle="heading3" className="margin-1-l"> Membership Rewards Enrolment </Heading>
            </div>
            <div className="border-dark-t pad-1-t margin-1-t body-3">
                {parse("Yes, I understand that I'll be automatically enrolled into Membership Rewards<sup>®</sup>.")}
            </div>

            <div className="flex margin-2-t">
                <IconPaperless theme={dlsBrightBlue} filled={true} title="accessibility icon" />
                <Heading level={2} headingStyle="heading3" className="margin-1-l"> Enrolment for Online Statements </Heading>
            </div>
            <div className="border-dark-t pad-1-t margin-1-t body-3">
            <Checkbox 
                    id="ConsentForOnlineStatements" onChange={valueChangeOnlineStatement} defaultChecked={true}
                    label="Yes, I prefer to receive my statements online. If I uncheck this option, I understand that I will get paper 
statements via post at my billing address. I can log in to my Card Account and change my statement preference anytime during my Card membership."
                    value={formData.onlineStatements}
                />
            </div>

            <div className="flex margin-2-t">
                <IconEmail theme={dlsBrightBlue} filled={true} title="accessibility icon" />
                <Heading level={2} headingStyle="heading3" className="margin-1-l"> Email Communications </Heading>
            </div>
            <div className="border-dark-t pad-1-t margin-1-t body-3">
                <Checkbox id="ConsentForEmailCommunication" name="ConsentForEmailCommunication" onChange={valueChangeEmailCommunication}
                defaultChecked={true}
                    label={parse(`Yes, I would like to receive emails informing me  about the benefits,
                        rewards and offers on my American Express Card. I understand my email address will
                        never be shared with others and I can easily opt-out later if I wish.`)}
                />
            </div>

            <div className="flex margin-2-t">
                <IconInsurance theme={dlsBrightBlue} filled={true} title="accessibility icon" />
                <Heading level={2} headingStyle="heading3" className="margin-1-l"> Other Benefits </Heading>
            </div>
            <div className="border-dark-t pad-1-t margin-1-t body-3">
                <Checkbox id="ConsentForInsurancePlanCommunication"
                    defaultChecked={true} onChange={valueChangeInsurancePlanCommunication}
                    label={`Yes, I would like to know about customized insurance plans exclusive to American 
                            Express Card members.`} />
            </div>
            <div className="margin-1-t body-3">
                <Checkbox id="ConsentForAdditionalPreviliges"
                    defaultChecked={true} onChange={valueChangeAdditionalPreviliges}
                    label="Yes, I wish to opt-in to receive additional privileges from American Express such as Standing Instructions, Supplementary Cards, etc."
                />
            </div>
            <div className="margin-1-t body-3">
                <Checkbox id="ConsentForMarketingCommunicationOverPhone"
                    defaultChecked={true} onChange={valueChangeMarketingCommunicationOverPhone}
                    label="Yes, I agree to receive any marketing communication from American Express through phone.
                            I hereby provide my consent to American Express to use my phone number for marketing purposes with respect to services and products it offers.
                            I further Agree to American Express sharing my information with its merchants, co-brand partners and / or affinity groups for marketing purposes."
                />
            </div>
            {/*<div className="margin-1-t body-3">*/}
            {/*    <RadioGroup*/}
            {/*        onChange={handleMITCCommunicationModeChange}*/}
            {/*        className="flex flex-align-items-start stack-1-r" >*/}
            {/*        <Legend>Please confirm the mode of communication to receive MITC and Agreement</Legend>*/}
            {/*        <RadioButton id="IsEmail" name="IsEmail" label="Digitally through Email" value="E" />*/}
            {/*        <RadioButton id="IsCurrentAddress" name="IsCurrentAddress" label="Physically through Post" value="A" />*/}
            {/*    </RadioGroup>*/}
            {/*    <Alert id="CommunicationMode-alert" show={errorData.communicationModeRequired}>Please make a selection.</Alert>*/}
            {/*</div>*/}
        </div>
    );
}
export default CommunicationPreference;